import { FocusableOption } from '@angular/cdk/a11y';
import { CdkListboxModule, CdkOption } from '@angular/cdk/listbox';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, computed, inject, signal } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tt-option',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkListboxModule],
  hostDirectives: [CdkOption],
  template: `<ng-content />`,
  styleUrl: 'select-option.component.scss',
})
export class SelectOptionComponent implements FocusableOption {
  private _cdkSelectOption = inject(CdkOption, { host: true });
  public elementRef = inject(ElementRef);

  public selected = computed(() => this._selected());
  public focused = computed(() => this._focused());
  public checkedState = computed(() => (this._selected() ? 'checked' : 'unchecked'));

  private _selected = signal<boolean>(false);
  private _focused = signal<boolean>(false);

  @Input()
  set value(value: unknown) {
    this._cdkSelectOption.value = value;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = value;
  }
  get disabled() {
    return this._disabled;
  }
  private _disabled = false;

  @HostListener('mouseenter')
  hoverOnMouseEnter(): void {
    this.focus();
  }

  /**
   * Selects the option.
   */
  public select(): void {
    this._selected.set(true);
    this._cdkSelectOption.select();
  }

  /**
   * Sets focus on the option.
   */
  public focus(): void {
    this._cdkSelectOption.focus();
    this._focused.set(true);
  }

  /**
   * Removes focus from the option.
   */
  public blur(): void {
    this._focused.set(false);
  }

  protected handleClick(): void {
    if (!this.disabled) {
      this.select();
    }
  }
}
